import { useEffect, useRef } from 'react'

// A small ticking analog face for the mobile nav, replacing the digital
// "McAllen, TX" chip Leo had pulled from the header entirely -- this one
// is mobile-only and genuinely animated (a continuous rAF sweep, not a
// once-a-minute text update) rather than a static badge.
export function AnalogClock() {
  const hourRef = useRef<SVGLineElement>(null)
  const minRef = useRef<SVGLineElement>(null)
  const secRef = useRef<SVGLineElement>(null)
  const liveRef = useRef<HTMLSpanElement>(null)
  const formatter = useRef(new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }))

  useEffect(() => {
    let raf = 0
    let lastMinute = -1

    function tick() {
      const now = new Date()
      const s = now.getSeconds() + now.getMilliseconds() / 1000
      const m = now.getMinutes() + s / 60
      const h = (now.getHours() % 12) + m / 60

      hourRef.current?.setAttribute('transform', `rotate(${h * 30} 18 18)`)
      minRef.current?.setAttribute('transform', `rotate(${m * 6} 18 18)`)
      secRef.current?.setAttribute('transform', `rotate(${s * 6} 18 18)`)

      const minute = now.getMinutes()
      if (minute !== lastMinute && liveRef.current) {
        liveRef.current.textContent = formatter.current.format(now)
        lastMinute = minute
      }

      raf = requestAnimationFrame(tick)
    }
    tick()
    return () => cancelAnimationFrame(raf)
  }, [])

  return (
    <div className="flex h-9 w-9 shrink-0 items-center justify-center">
      <svg viewBox="0 0 36 36" className="h-6 w-6" aria-hidden="true">
        <circle cx="18" cy="18" r="16" fill="none" stroke="var(--n-500)" strokeWidth="1.5" />
        <line ref={hourRef} x1="18" y1="18" x2="18" y2="11" stroke="var(--ink)" strokeWidth="2" strokeLinecap="round" />
        <line ref={minRef} x1="18" y1="18" x2="18" y2="7" stroke="var(--ink)" strokeWidth="1.5" strokeLinecap="round" />
        <line ref={secRef} x1="18" y1="18" x2="18" y2="5.5" stroke="var(--accent)" strokeWidth="1" strokeLinecap="round" />
        <circle cx="18" cy="18" r="1.4" fill="var(--ink)" />
      </svg>
      <span ref={liveRef} className="sr-only" />
    </div>
  )
}
